import React from 'react'
import { useTranslation } from 'react-i18next';
import '../styles/underdev.css';

const UnderDev = () => {

    const { t } = useTranslation('under-dev');

    return (
        <section className="bl-under-dev section-block">
        <div className="under-dev-container">
            <div className="under-dev-stripe">
                <img className='under-dev-stripe-svg' src='/images/under-dev-stripe.svg' alt='Me standing next to SF bridge' />
            </div>
            <div className='under-dev-text'>
                <h2 className='hero-title'> {t('title')} </h2>
                <p>  {t('desc')} </p>
            </div>
            <div className="under-dev-stripe">
                <img className='under-dev-stripe-svg flipy' src='/images/under-dev-stripe.svg' alt='Me standing next to SF bridge' />
            </div>
            <div className="under-dev-stripe">
                <img className='under-dev-stripe-svg' src='/images/under-dev-stripe.svg' alt='Me standing next to SF bridge'/>
            </div>
        </div>
        </section>
    )
}

export default UnderDev;